import React,{ Component } from 'react';
import { Line } from 'react-chartjs-2';
import moment from "moment";
import { Spinner } from "reactstrap";
import { connect } from "react-redux";
import { getAgentGraph } from "../../../../actions/actionReporting";
import Proptypes from "prop-types";

const options = {
    tooltips: {
        enabled: true,
        mode: 'index',
        intersect: false,
        callbacks: {
            label: function(tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label || '';

                if (label) {
                    label += ': ';
                }
                label += tooltipItem.yLabel.toFixed(0);
                return label;
            }
        }
    },
    hover: {
        mode: 'index',
        intersect: false
    },
    scales: {
        yAxes: [
            {
                ticks: {
                    display: true,
                    min: 0,
                    max: 100,
                },
            }],
        xAxes: [
            {
                ticks: {
                    autoSkip: true,
                    autoSkipPadding: 60,
                    maxRotation: 0,
                    minRotation: 0,
                    userCallback: function(label) {
                        let arr = label.split(/\s+/);
                        if (arr.length === 3) {
                            arr[1] = arr[1] + ' ' + arr[2];
                            arr.length = 2;
                            return arr;
                        } else
                            return label;
                    }
                },
            }],
    },
    maintainAspectRatio: false,
    elements: {
        line: {
            tension: 0.2,
            borderWidth: 3,
        },
        point: {
            radius: 1,
            hitRadius: 10,
            hoverRadius: 4,
        },
    }
};

class AgentGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    createGraph() {
        const convertedLabels = this.props.agentGraph && this.props.agentGraph.labels.map((label, i) => {
            return moment.utc(label,"YYYYMMDDHHmm").local().format("MM/DD/YY LT")
        });

        let line = {};
        if (this.props.agentGraph) {
            line = {
                labels: convertedLabels,
                datasets: [
                    {
                        label: 'Avg Disk Percent',
                        fill: false,
                        borderColor: '#46b344',
                        backgroundColor: '#46b344',
                        data: this.props.agentGraph.avg_disk_percent,
                    },
                    {
                        label: 'Avg Memory Percent',
                        fill: false,
                        backgroundColor: '#a7ccfc',
                        borderColor: '#a7ccfc',
                        data: this.props.agentGraph.avg_memory_percent,
                    },
                    {
                        label: 'Max Memory Percent',
                        fill: false,
                        backgroundColor: '#006cff',
                        borderColor: '#006cff',
                        data: this.props.agentGraph.max_memory_percent,
                    },
                    {
                        label: 'Avg CPU Percent',
                        fill: true,
                        borderColor: '#c5cdd9',
                        data: this.props.agentGraph.avg_cpu_percent,
                    },
                    {
                        label: 'Max CPU Percent',
                        fill: false,
                        borderColor: '#e86f7f',
                        backgroundColor: '#e86f7f',
                        data: this.props.agentGraph.max_cpu_percent,
                    }
                ]
            };
        }
       return  <Line data={line} options={options}/>
    }

    componentDidMount() {
        let report = this.props.timeData();
        report.filters = {server_id: this.props.server_id};
        this.props.getAgentGraph(report)
            .then(() => {
                this.setState({graph: this.createGraph()})
            } );
    }

    render() {
        return (
            <React.Fragment>
                {this.state.graph ?
                    <div style={{'height': '400px'}}>
                        {this.state.graph}
                    </div>
                    :
                    <span className={"agentcard"}><Spinner color="primary" /></span>
                }
            </React.Fragment>
        );
    }
}

AgentGraph.propTypes = {
    // timeData: Proptypes.function,
    // server_id: Proptypes.string.isRequired
};

export default connect(state =>
        ({
            agentGraph: state.reporting.agentGraph,
        }),
    dispatch =>
        ({
            getAgentGraph: (data) => dispatch(getAgentGraph(data)),
        }))(AgentGraph);


// WEBPACK FOOTER //
// ./src/views/Reporting/ReportDashboard/ReportComponents/AgentGraph.js